// Libs
import React, { PureComponent } from 'react'
import _map from 'lodash/map'
import _capitalize from 'lodash/capitalize'
import _isEqual from 'lodash/isEqual'
import _find from 'lodash/find'
import _pull from 'lodash/pull'
import _reduce from 'lodash/reduce'
import _sumBy from 'lodash/sumBy'
import _get from 'lodash/get'
import _isEmpty from 'lodash/isEmpty'
import moment from 'moment'

// Components
import Select from 'react-select'
import FormField from '@react-mdc/form-field'
import Typography from '@react-mdc/typography'
import Radio from '@react-mdc/radio'
import { Feature } from '../FeaturesOfField'
import Checkbox from '@react-mdc/checkbox'

// Constants
import { ADD, EDIT } from 'fc-operations/src/constants'

// utils
import unitConversion from 'hfty-utils/unitConversion'

// Styles
import { white, primary } from 'hfty-styles/src/colors'

import {
  SET_GRID,
  READY_TO_SAMPLE,
  PROP_CREATED_DATE,
  // ORDER_TEST,
  // SHIPPING,
  // RESULTS_POSTED,
} from 'fc-model-sampling-jobs'

import { GRID_UNIT_CHOICES, GRID_UNIT_ACRES, GRID_UNIT_HECTARES } from 'hfty-model-grid'

// Types
import type { Point } from 'fc-model-sampling-points/types'

const statusType = [
  SET_GRID,
  READY_TO_SAMPLE,
  // ORDER_TEST, SHIPPING, RESULTS_POSTED,
]

const statusOptions = _map(statusType, (status) => {
  return { value: status, label: status }
})

const unitOptions = _map(GRID_UNIT_CHOICES, (unit) => {
  return { value: unit, label: _capitalize(unit) }
})
export type Props = {
  usersSelectorOptions: Array<Object>,
  operation: Object,
  fieldSelectorOptions: ?Array<{ value: Number, label: string }>,
  selectedFieldId: ?Number,
  area: ?Number,
  gridData: ?Object,
  featuresOfSoilJob: Array<Object>,
  selectedFeatureIndices: Array<Number>,
  hoverFeatureIndex: number,
  onUpdateJob: Function,
  onSelectFeature: Function,
  previousPoints: Array<Point>,
  isPreviousPointsShown: boolean,
  showPreviousPoints: Function,
}

// Local Styles
const INDENT = '15px'
const styles = {
  container: {
    padding: `${INDENT} 0`,
  },
  h2: {
    fontSize: '1.25em',
    fontWeight: '400',
    lineHeight: '1.4em',
    letterSpacing: '-0.5px',
    marginBottom: '1em',
  },
  jobDetails: {
    margin: '30px 0',
    padding: INDENT,
    background: white(),
    border: '1px solid rgb(220, 218, 218)',
  },
  h3: {
    margin: '0.5em 0 1em',
    fontSize: '1.1em',
    fontWeight: 400,
    lineHeight: '1.4em',
    letterSpacing: '-0.5px',
    textDecoration: 'underline',
  },
  dataTable: {
    fontSize: '0.875rem',
  },
  tdTitle: {
    fontWeight: 'bold',
    padding: '7px 20px 5px 0',
    whiteSpace: 'nowrap',
  },
  tdValue: {
    padding: '7px 0',
  },
  toolBarGroup: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: 5,
    marginBottom: INDENT,
    borderRadius: 2,
    backgroundColor: white(),
    boxShadow: '0 0 2px rgba(0, 0, 0, 0.2)',
    fontSize: '0.9em',
  },
  label: {
    marginRight: 30,
  },
  lockedAllFeatures: {
    marginBottom: INDENT,
    backgroundColor: primary(),
    color: white(),
    textAlign: 'center',
    boxShadow: '0 0 2px rgba(0, 0, 0, 0.2)',
  },
  checkboxWrapper: {
    display: 'flex',
    marginTop: 30,
    fontSize: '.875rem',
    alignItems: 'center',
  },
  checkbox: {
    position: 'absolute',
    margin: '0 4px 0 -11px',
  },
  checkboxLabel: {
    paddingLeft: '32px',
  },
}

export default class AddJobForm extends PureComponent {
  props: Props

  constructor(props) {
    super(props)
    this.state = {
      gridWholeField: props.featuresOfSoilJob.length <= 1,
      gridPerFeature: props.featuresOfSoilJob.length > 1,
      griddingType: props.featuresOfSoilJob.length <= 1 ? 'gridWholeField' : 'gridPerFeature',
    }
    this.onChangeStatus = this.onChangeStatus.bind(this)
    this.onChangeAssignee = this.onChangeAssignee.bind(this)
    this.onSelectFeature = this.onSelectFeature.bind(this)
    this.onChangeUnits = this.onChangeUnits.bind(this)
    this.onGridEntireField = this.onGridEntireField.bind(this)
    this.onGridPerFeature = this.onGridPerFeature.bind(this)
    this.onChangePrevPointCheckbox = this.onChangePrevPointCheckbox.bind(this)
    // this.onChangeGriddingType = this.onChangeGriddingType.bind(this)
  }

  componentWillReceiveProps(nextProps) {
    if (!_isEqual(nextProps, this.props) && nextProps.featuresOfSoilJob.length <= 1) {
      const { featuresOfSoilJob, onSelectFeature } = nextProps

      const indices = _map(featuresOfSoilJob, (feature) => feature.properties.featureIndex)

      onSelectFeature(indices)
    }

    if (!_isEqual(nextProps, this.props) && nextProps.featuresOfSoilJob.length > 1 && this.state.gridWholeField) {
      const { featuresOfSoilJob, onSelectFeature } = nextProps

      const indices = _map(featuresOfSoilJob, (feature) => feature.properties.featureIndex)

      onSelectFeature(indices)
    }
  }

  onChangeStatus = (value) => {
    this.props.onUpdateJob({
      ...this.props.operation,
      model: {
        job: {
          ...this.props.operation.model.job,
          status: value.value,
        },
      },
    })
  }
  onChangeAssignee = (value) => {
    this.props.onUpdateJob({
      ...this.props.operation,
      model: {
        job: {
          ...this.props.operation.model.job,
          assigned_to: value.value,
        },
      },
    })
  }

  onSelectFeature(index) {
    const { selectedFeatureIndices, operation, onUpdateJob } = this.props
    const { grid = [] } = operation.model.gridData
    let newSelectedIndices = selectedFeatureIndices || []

    const selectedIndex = _find(selectedFeatureIndices, (featureIndex) => featureIndex === index)

    if (selectedIndex || selectedIndex === 0) {
      newSelectedIndices = _pull(selectedFeatureIndices, index)
    } else {
      newSelectedIndices.push(index)
    }

    if (grid[index]) {
      onUpdateJob({
        ...operation,
        model: {
          gridData: {
            grid: {
              ...grid,
              transformations: {
                ...grid[index],
              },
            },
          },
        },
      })
    }

    this.props.onSelectFeature(newSelectedIndices)
  }

  onChangeUnits = ({ value }) => {
    this.props.onUpdateJob({
      ...this.props.operation,
      model: {
        ...this.props.operation.model,
        gridData: {
          ...this.props.operation.model.gridData,
          grid: {
            ...this.props.operation.model.gridData.grid,
            units: value,
          },
        },
      },
    })
  }

  onGridEntireField() {
    const { featuresOfSoilJob, onSelectFeature } = this.props

    const indices = _map(featuresOfSoilJob, (feature) => feature.properties.featureIndex)
    onSelectFeature(indices)
    this.setState({ gridWholeField: true, gridPerFeature: false })
  }

  onGridPerFeature() {
    const { onSelectFeature } = this.props
    onSelectFeature([])
    this.setState({ gridWholeField: false, gridPerFeature: true })
  }

  onChangePrevPointCheckbox(e: Event) {
    this.props.showPreviousPoints(e.target.checked)
  }

  // onChangeGriddingType ({target: {value}}) {
  //   debugger
  //   const { featuresOfSoilJob, onSelectFeature } = this.props
  //
  //   if (value === 'gridPerFeature') {
  //     onSelectFeature([])
  //   }
  //   else if (value === 'gridWholeField') {
  //     const indices = _map(featuresOfSoilJob, (feature) => feature.properties.featureIndex)
  //     onSelectFeature(indices)
  //   }
  //
  //   this.setState({griddingType: value})
  // }

  getEstimatedSamples() {
    const { gridData } = this.props

    const points = _reduce(
      gridData,
      (acc, { gridPoints }) => {
        _sumBy(gridPoints, (point) => {
          if (point) {
            acc += 1
          }
        })

        return acc
      },
      0
    )

    return points
  }

  render(): React.element<any> {
    const operation = this.props.operation
    const operationType = this.props.operation.operation
    const jobStatus = operation.model.job.status || null
    const gridSize = operation.model.gridData.grid.transformations.size
    const gridSizeUnits = operation.model.gridData.grid.units || GRID_UNIT_ACRES
    const fieldLabel = _find(
      this.props.fieldSelectorOptions,
      (field) => field.value === this.props.selectedFieldId
    ).label
    const fieldArea =
      gridSizeUnits === GRID_UNIT_ACRES
        ? this.props.area
        : unitConversion(this.props.area, GRID_UNIT_ACRES, GRID_UNIT_HECTARES)
    const jobDetail = _get(this.props, 'operation.model.job', {})
    const jobId = jobDetail.id || ''
    const recordDate = jobDetail[PROP_CREATED_DATE] ? moment(jobDetail[PROP_CREATED_DATE], 'X').format('L') : '-'
    const shouldRenderPrevPointsCheckbox =
      operationType === EDIT && this.props.previousPoints && this.props.previousPoints.length > 0

    return (
      <div style={styles.container}>
        <h2 style={styles.h2}>{operationType === ADD ? 'Add New Job' : 'Edit Job'}</h2>
        <div className="select-group-aligned-right w73">
          <FormField>
            <label htmlFor="assign-to-selector">Assign To</label>
            <Select
              name="assign-to-selector"
              placeholder="Select an Assignee"
              disabled={_isEmpty(this.props.usersSelectorOptions)}
              value={operation.model.job.assigned_to}
              options={this.props.usersSelectorOptions}
              onChange={this.onChangeAssignee}
              className="clear-margin"
            />
          </FormField>
          <FormField>
            <label htmlFor="status-selector">Status</label>
            <Select
              name="status-selector"
              placeholder="Select a Status"
              value={jobStatus}
              options={statusOptions}
              onChange={this.onChangeStatus}
              className="clear-margin"
            />
          </FormField>
          <FormField>
            <label htmlFor="grid-unit-selector">Area Units</label>
            <Select
              name="grid-unit-selector"
              value={gridSizeUnits}
              options={unitOptions}
              onChange={this.onChangeUnits}
              className="clear-margin"
            />
          </FormField>
        </div>
        {shouldRenderPrevPointsCheckbox && (
          <div style={styles.checkboxWrapper}>
            <Checkbox.Default
              id="show-prev-points"
              name="show-prev-points"
              checked={this.props.isPreviousPointsShown}
              onChange={this.onChangePrevPointCheckbox}
              style={styles.checkbox}
              className="thin-border"
            />
            <label htmlFor="show-prev-points" style={styles.checkboxLabel}>
              {`View Previous Season's Sampling Points`}
            </label>
          </div>
        )}
        <div>
          <div style={styles.jobDetails}>
            <h3 style={styles.h3}>{operationType === ADD ? 'New Job Details' : 'Job Details'}</h3>
            <table style={styles.dataTable}>
              <tbody>
                <tr>
                  <td style={styles.tdTitle}>Job Id:</td>
                  <td style={styles.tdValue}>{jobId}</td>
                </tr>
                <tr>
                  <td style={styles.tdTitle}>Field:</td>
                  <td style={styles.tdValue}>{fieldLabel}</td>
                </tr>
                <tr>
                  <td style={styles.tdTitle}>Area:</td>
                  <td style={styles.tdValue}>
                    {Math.round(fieldArea)} {gridSizeUnits}
                  </td>
                </tr>
                <tr>
                  <td style={styles.tdTitle}>Grid Size:</td>
                  <td style={styles.tdValue}>
                    {this.state.gridPerFeature ? 'multi-grid' : `${gridSize} ${gridSizeUnits}`}
                  </td>
                </tr>
                <tr>
                  <td style={styles.tdTitle}>Estimated:</td>
                  <td style={styles.tdValue}>{this.props.gridData ? this.getEstimatedSamples() : 0} samples</td>
                </tr>
                <tr>
                  <td style={styles.tdTitle}>Record Date:</td>
                  <td style={styles.tdValue}>{recordDate}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        {this.props.featuresOfSoilJob.length <= 1 ? null : (
          <div style={styles.toolBarGroup}>
            <Radio.Default
              id="singleGrid"
              name="grid"
              onChange={this.onGridEntireField}
              value="gridWholeField"
              checked={this.state.gridWholeField}
            />
            <label style={styles.label} htmlFor="display.All">
              Entire Field
            </label>
            <Radio.Default
              id="multipleGrids"
              name="grid"
              onChange={this.onGridPerFeature}
              value="gridPerFeature"
              checked={this.state.gridPerFeature}
            />
            <label htmlFor="display.All">Per Feature</label>
          </div>
        )}
        {this.state.gridPerFeature &&
        this.props.selectedFeatureIndices &&
        this.props.selectedFeatureIndices.length === 0 ? (
          <Typography style={styles.lockedAllFeatures}>
            <Typography.Text textStyle="body2">{'**All features are locked**'}</Typography.Text>
            <Typography.Text textStyle="body2">{'Unlock features to edit or submit to save'}</Typography.Text>
          </Typography>
        ) : null}
        {this.props.featuresOfSoilJob.length <= 1 || this.state.gridWholeField
          ? null
          : _map(this.props.featuresOfSoilJob, (feature, index) => {
              const isHovering = this.props.hoverFeatureIndex === feature.properties.featureIndex

              return (
                <Feature
                  {...this.props}
                  key={index}
                  isJobFeature
                  feature={feature}
                  index={index}
                  isHovering={isHovering}
                  onSelectFeature={this.onSelectFeature}
                />
              )
            })}
      </div>
    )
  }
}
